const Index = () => import('./index.vue');
const CreatePage = () => import('./_pages/create.vue');
const ViewPage = () => import('./_pages/view.vue');
const BalancesPage = () => import('./_pages/balances.vue');

export default [
    {
        path: '/customers',
        name: 'CustomersPage',
        component: Index
    },
    {
        path: '/new-customer',
        name: 'NewCustomerPage',
        component: CreatePage
    },
    {
        path: '/customer/:id',
        component: ViewPage
    },
    {
        path: '/customer/balances/:id',
        component: BalancesPage
    }
]